module.exports = __webpack_public_path__ + "static/media/Client8ProfileProperties.ad398c2d.png";